import { useAppDispatch } from '../../../App/redux/store';
import Button from '../../../components/Assets/Button';
import useAuth from '../../auth/useAuth';
import { modalsActions } from '../../modals/modalsSlice';
import useSubscription from '../hooks/useSubscription';

function SubscriptionUpdateButton() {
  const { subscription, subscriptionIdIri, subscriptionDemandExists } =
    useSubscription();
  const { isManager } = useAuth({});
  const dispatch = useAppDispatch();

  const handleUpdateSubscription = () =>
    dispatch(modalsActions.askForSubscriptionUpdate(true));

  if (!isManager || subscription?.hasRequest) return null;

  return (
    <Button
      btnType="button"
      btnContent="MODIFIER MON ABONNEMENT"
      handleClick={handleUpdateSubscription}
      primary
      disabled={!subscriptionIdIri || subscriptionDemandExists}
    />
  );
}

export default SubscriptionUpdateButton;
